export default "__VITE_ASSET__C5gO868n__"